import { Check } from 'lucide-react';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: React.ReactNode;
  disabled?: boolean;
  className?: string;
}

export function Checkbox({ checked, onChange, label, disabled = false, className = '' }: CheckboxProps) {
  return (
    <div className={`tw-flex tw-items-center tw-gap-3 tw-select-none ${disabled ? 'tw-opacity-50' : ''} ${className}`}>
      <div
        onClick={() => !disabled && onChange(!checked)}
        className={`tw-w-5 tw-h-5 tw-rounded-md tw-border-2 tw-flex tw-items-center tw-justify-center tw-transition-all tw-flex-shrink-0 ${
          disabled ? 'tw-cursor-not-allowed' : 'tw-cursor-pointer'
        } ${
          checked
            ? 'tw-bg-affinicar-primary tw-border-affinicar-primary'
            : 'tw-bg-white tw-border-gray-300'
        }`}
      >
        {checked && <Check className="tw-w-3.5 tw-h-3.5 tw-text-white" strokeWidth={3} />}
      </div>
      {label && <span className="tw-text-sm tw-font-medium tw-text-gray-900">{label}</span>}
    </div>
  );
}
